((function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("mainSection", {
        templateUrl: "app/main.component.html",
        controller: ["authService", "colorService", "frameworkService", "learningPlanService", "logoService", "messageService", "sessionService", "gamificationNotificationService", "tenantResource", "$localStorage", "$location", "$rootScope", "$scope", "$translate", "$state", "$timeout", MainCtrl],
        controllerAs: "main"
    });
    function MainCtrl(authService, colorService, frameworkService, learningPlanService, logoService, messageService, sessionService, gamificationNotificationService, tenantResource, $localStorage, $location, $rootScope, $scope, $translate, $state, $timeout) {
        var vm = this;
        vm.activeMenu = "dashboard";
        vm.frameworkData = frameworkService.data;
        vm.tenant = vm.frameworkData.tenant;
        vm.previewMode = false;
        vm.previewModeNG2 = false;
        vm.subscriptionExpired = false;
        vm.overUsers = false;
        vm.userDetails = authService.authentication;
        vm.authService = authService;
        vm.showPageLoader = $rootScope.showPageLoader;
        if (!$localStorage.tenantSettings) {
            $localStorage.tenantSettings = {};
        }
        $rootScope.main = vm;
        $translate.refresh();
        //GOAL - If someone signs in with a different account in a different tab or browser, reload the page to fetch new account's data.
        $rootScope.$watch(function () { return $localStorage.authorizationData2; }, function (newValue, oldValue) {
            if (newValue && oldValue !== newValue) {
                if (authService.refreshAuthData()) {
                    $timeout(function () {
                        $state.reload();
                    }, 500);
                }
            }
            else if (newValue == null && oldValue) {
                $state.reload();
            }
            //2025-05-26 - testing commenting this out.
            //Should we do a different Broadcast here? What is not working above?
            //This is a workaround for the issue where localStorage is not updated in time in DotNet6 Angular application.
            //DotNet6 Angular localStorage is not updated in time unless we delay the broadcast
            //if (newValue && !oldValue) {
            //	$timeout(() => {
            //		$rootScope.$broadcast("signInComplete", false);
            //	}, 200);
            //}
        });
        if (vm.userDetails.isAuth) {
            if (authService.isSuperAdmin())
                checkSubscription();
            sessionService.init();
        }
        function checkSubscription() {
            tenantResource.checkSubscription(function (data) {
                vm.subscriptionExpired = data.isExpired;
                vm.overUsers = data.isOverActiveUsers;
                vm.subscriptionCheck = data;
                vm.subscriptionIssue = vm.subscriptionCheck.isExpired || vm.subscriptionCheck.isOverActiveUsers || vm.subscriptionCheck.hasUnpaidBill;
            }, function () { });
        }
        $scope.$on("checkSubscription", function () {
            if (authService.isSuperAdmin())
                checkSubscription();
        });
        $scope.$on("clearSubscriptionNotify", function () {
            vm.subscriptionExpired = false;
            vm.overUsers = false;
            vm.subscriptionIssue = false;
            if (vm.subscriptionCheck)
                vm.subscriptionCheck.hasPartiallyPaidBill = false;
        });
        vm.viewSubscription = function () {
            $state.go("main.settings.subscription");
        };
        loadTenantSettings();
        //#region ThemePreview
        var previewNotify;
        $scope.$on("previewTheme", function () {
            vm.previewMode = true;
            //if (previewNotify)
            //	previewNotify.close();
            //previewNotify = messageService.custom({ duration: 0, messageTemplate: "<span translate='settings.theme.colors.preview.help'></span>", classes: "alert-warning" });
        });
        $scope.$on("dismissPreviewTheme", function () {
            vm.previewMode = false;
            if (previewNotify)
                previewNotify.close();
        });
        $scope.$on("cancelPreview", function () {
            vm.cancelPreview();
        });
        $scope.$on("savePreview", function () {
            vm.savePreview();
        });
        vm.savePreview = function () {
            vm.previewMode = false;
            colorService.saveColors().then(function () {
                if (previewNotify)
                    previewNotify.close();
                $rootScope.$broadcast("closePreviewAngularTheme", { resetA2Colors: false }); //closes A2 PNB
                messageService.success("common.changesSaved");
            }, function () {
                if (previewNotify)
                    previewNotify.close();
                $rootScope.$broadcast("closePreviewAngularTheme", { resetA2Colors: false }); //closes A2 PNB
                messageService.error("common.genericError");
            });
        };
        vm.cancelPreview = function () {
            vm.previewMode = false;
            if (previewNotify)
                previewNotify.close();
            colorService.resetSiteColors();
            $rootScope.$broadcast("closePreviewAngularTheme", { resetA2Colors: true }); //closes and reset A2 PNB and colors
        };
        //#endregion
        $scope.$on("updateCurrentUserData", function (_event, params) {
            authService.updateUserData(params);
        });
        $scope.$on("reloadAngularJsTenantSettings", function () {
            /*tenantResource.removeSettingsFromCache();*/
            frameworkService.init(function (newTenant) {
                vm.tenant = newTenant;
                loadTenantSettings();
                $rootScope.$broadcast("reloadMenu");
            });
        });
        //#updateShoppingCartCount
        //$scope.$on("updateShoppingCartCountFromAngular", () => {
        //	$localStorage.$sync();
        //	//$rootScope.$broadcast("updateShoppingCartCount")
        //	$rootScope.$broadcast("updateShoppingCartCount", shoppingCartService.getCartCount());
        //});
        //var cleanup = setupSignalREventListeners();
        //#region signalR
        $scope.$on('$destroy', setupSignalREventListeners());
        function setupSignalREventListeners() {
            console.log("** setup SignalR Event Listeners");
            var watcherUserSignedIn = $rootScope.$on("UserSignedIn", signalRUserSignedIn);
            var watcherUserSignedOut = $rootScope.$on("SignalRUserSignedOut", signalRUserSignedOut);
            var watcherRefreshLearningPlan = $rootScope.$on("RefreshLearningPlan", signalRRefreshLearningPlan);
            var watcherShowPointsCollectedNotification = $rootScope.$on("ShowPointsCollectedNotification", signalRShowPointsCollectedNotification);
            var watcherShowTierAchievedNotification = $rootScope.$on("ShowTierAchievedNotification", signalRShowTierAchievedNotification);
            return function cleanUp() {
                console.log("main.component: cleanup()");
                watcherUserSignedIn();
                watcherUserSignedOut();
                watcherRefreshLearningPlan();
                watcherShowPointsCollectedNotification();
                watcherShowTierAchievedNotification();
            };
        }
        function signalRUserSignedIn() {
            //This is called from signalr in backend prior to front end logging in the new user
            sessionService.destroy();
            authService.logOut().then(function () {
                $state.go("main.signIn.signedInInADifferentBrowser");
            });
        }
        function signalRUserSignedOut() {
            sessionService.destroy();
            authService.logOut().then(function () {
                $state.go("main.signIn", {}, { reload: true });
            });
        }
        function signalRRefreshLearningPlan() {
            console.log("main.component: signalRRefreshLearningPlan");
            learningPlanService.refresh(function () {
                $rootScope.$broadcast("learningPlanRefreshed");
            });
        }
        function signalRShowPointsCollectedNotification(_event, data) {
            gamificationNotificationService.pointsCollected(data.icon, data.message, data.points);
        }
        function signalRShowTierAchievedNotification(_event, data) {
            gamificationNotificationService.tierAchieved(data.icon, data.tier);
        }
        //#endregion
        this.$onDestroy = function () {
            console.log("** Destroy Main");
            sessionService.destroy();
        };
        function loadTenantSettings() {
            if (vm.tenant.id === 0) {
                //$location.url("/tenantNotFound.html");
                //$rootScope.$broadcast("NOT-FOUND");
                return;
            }
            logoService.logo = vm.tenant.logoUrl;
            $localStorage.tenantSettings = vm.tenant;
            //vm.tenantSettings = tenant;
            //$localStorage.tenantSettings = vm.tenantSettings;
            colorService.setSiteColors(vm.tenant.primaryColor, vm.tenant.secondaryColor, vm.tenant.primaryTextColor, vm.tenant.secondaryTextColor);
        }
        //vm.getUserPictureUrl = () => {
        //	return authService.authentication.pictureUrl;
        //};
        //#region Lectora Session
        //Clear Lectora sessionStorage
        var removeArray = [];
        for (var i = 0; i < sessionStorage.length; i++) {
            if (sessionStorage.key(i).startsWith("Lectora")) {
                removeArray.push(sessionStorage.key(i));
            }
        }
        for (var key in removeArray) {
            if (removeArray.hasOwnProperty(key)) {
                sessionStorage.removeItem(removeArray[key]);
            }
        }
        //#endregion
    }
})());
